let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8scXF")).then(() => parcelRequire('6LNAz'));